import { GroupNavCarousel } from 'app/features/group/components'
import { canAccessPosts, hasJoinedGroup } from 'app/features/group/helpers'
import {
  GroupQueryInput,
  GroupQueryOutput,
  UserGroupsQueryInput,
  UserGroupsQueryOutput,
  groupQuery,
  userGroupJoinRequestsQuery,
  userGroupsQuery,
} from 'app/features/group/queries'
import { GroupScreen } from 'app/features/group/screens'
import { groupPostsQuery } from 'app/features/group/screens/group-screen/queries'
import { addApolloState, initializeApollo } from 'lib/initialize-apollo'
import { withAuthedPage } from 'lib/session'
import { GetServerSideProps } from 'next'

export default function Page() {
  return <GroupScreen HeaderComponent={<GroupNavCarousel />} />
}

export const getServerSideProps: GetServerSideProps = withAuthedPage(async ({ req, query }) => {
  const user = req?.session?.user
  const id = query?.id as string

  if (!id) {
    return {
      notFound: true,
    }
  }

  const client = initializeApollo({ token: user?.token })

  try {
    const groupData = await client.query<GroupQueryOutput, GroupQueryInput>({
      query: groupQuery.query,
      variables: {
        id,
      },
    })

    const group = groupData.data.Group

    if (!group) {
      return {
        notFound: true,
      }
    }

    if (user) {
      const userGroups = await client.query<UserGroupsQueryOutput, UserGroupsQueryInput>({
        query: userGroupsQuery.query,
        variables: {
          ...userGroupsQuery.defaultVariables,
        },
      })

      await client.query({
        query: userGroupJoinRequestsQuery.query,
        variables: {
          ...userGroupJoinRequestsQuery.defaultVariables,
        },
      })

      const { isMember } = hasJoinedGroup({
        userGroups: userGroups?.data?.userGroups?.docs || [],
        groupId: group?.id || '',
      })

      const canReadPosts = canAccessPosts({
        group,
        user,
        isMember,
      })

      if (canReadPosts) {
        await client.query({
          query: groupPostsQuery.query,
          variables: {
            ...groupPostsQuery.defaultVariables,
            id: group.id,
          },
        })
      }
    }
  } catch (error) {
    console.error(error)
    return {
      notFound: true,
    }
  }

  return addApolloState(client, {
    props: {
      user: user || null,
    },
  })
})
